import { render, staticRenderFns } from "./FileImport.vue?vue&type=template&id=4cc73140&scoped=true&"
import script from "./FileImport.vue?vue&type=script&lang=js&"
export * from "./FileImport.vue?vue&type=script&lang=js&"
import style0 from "./FileImport.vue?vue&type=style&index=0&id=4cc73140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc73140",
  null
  
)

export default component.exports